import './Footer.css';

export default function Footer() {
    return (
        <footer className="footer">

            <p className="footer__text">
                Хочешь такой же сайт себе?
            </p>

            <a
                className="footer__link"
                href="https://t.me/nikitapoluchaetcya"
                target="_blank"
                rel="noreferrer"
            >
                Напиши мне в Telegram @nikitapoluchaetcya
            </a>

            <p className='footer__text text--small'>Кувшинников Никита Владимирович ИНН: 730996708699</p>

        </footer>
    );
}